import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import Platform from './Index';
import Maintenance from './Maintenance';
import { routes } from '../routes';
import TrialEnd from './TrialEnd';
import TrialEndCancelSurvey from './TrialEndCancelSurvey';
import TrialEndSuccess from './TrialEndSuccess';
import NPSSurveyPage from './NpsSurveyPage';
import NpsSurveyAlert from './NpsSurveyAlert';
import { NpsProvider } from '../contexts/NpsContext';
import SettingsPaymentMethods from './SettingsPaymentMethods';
import { useAppcues, useUser } from '@increasecard/increase-core';
import Invoices from './Invoices';
import Payments from './Payments';
import SettingsBilling from './SettingsBilling.jsx';
import SettingsUsers from './SettingsUsers';
import PaySettingsBilling from './PaySettingsBilling';
import PayCheckoutSuccess from './PayCheckoutSuccess';
import SettingsMe from './SettingsMe';
import SettingsUser from './SettingsUser';
import { Support } from './Support';
import AggregatorAccountUsers from './AggregatorAccountUsers.jsx';

export function Routes() {
  const location = useLocation();
  const activeUser = useUser();
  useAppcues('platform', location.pathname);

  const isLegacy = activeUser?.isLegacyAccount();

  return (
    <>
      <Switch>
        {!isLegacy && (
          <>
            <Redirect from="*" to={routes.advanced.index} />
            <Route component={AggregatorAccountUsers} exact path={routes.advanced.index} />
          </>
        )}
        {isLegacy && (
          <>
            <Route component={Platform} exact path={routes.platform.home} />
            <Route component={Maintenance} exact path={routes.maintenance} />
            <Route component={Invoices} exact path={routes.invoices.index} />
            <Route component={Payments} exact path={routes.payments} />
            <Route component={Support} exact path={routes.support} />
            <Route component={SettingsBilling} exact path={routes.invoices.settings.billing} />
            <Route
              component={SettingsPaymentMethods}
              exact
              path={routes.invoices.settings.paymentMethods}
            />
            <Route component={SettingsUsers} exact path={routes.advanced.index} />
            <Route component={SettingsUser} exact path="/advanced/settings/users/:id" />
            <Route
              component={SettingsMe}
              path={[routes.platform.settings.user, routes.platform.settings.index]}
            />
            <Route component={TrialEndSuccess} exact path="/trialEnd/success" />
            <Route component={TrialEnd} exact path="/trialEnd/:productCodename" />
            <Route
              component={TrialEndCancelSurvey}
              exact
              path="/trialEnd/cancel/:productCodename"
            />
            <Route component={NPSSurveyPage} exact path="/npsSurvey/:productName" />
            <Route component={PaySettingsBilling} exact path="/pay/billing" />
            <Route component={PayCheckoutSuccess} exact path="/pay/success" />
          </>
        )}
      </Switch>
      <NpsProvider>
        <NpsSurveyAlert />
      </NpsProvider>
    </>
  );
}
